import { beatCoefficient } from '@arpeggi/audio'
import { deserializeStemSnapshot, isValidComposition, StemType } from '@arpeggi/shared'
import { IStemStore } from '../StemStore'
import { AudioStemStore } from './AudioStemStore'
import { DrumStemStore } from './DrumStemStore'
import { InstrumentStemStore } from './InstrumentStemStore'

export const deserializeStemFromStorage = (serializedStem: any): IStemStore => {
  // Some stems don't have arpeggi composition and don't need to be deserialized.
  if (!isValidComposition(serializedStem)) {
    return null
  }
  const stemSnapshot = deserializeStemSnapshot(serializedStem)
  switch (stemSnapshot.stemType) {
    case StemType.INSTRUMENT:
      return InstrumentStemStore.create(stemSnapshot)
    case StemType.DRUMS:
      return DrumStemStore.create(stemSnapshot)
    case StemType.AUDIO:
      return AudioStemStore.create(stemSnapshot)
  }
}

export function generateSeqArray(array: any[], loopBeatDivision: number, maxBeatDivision) {
  const loopLength = 32
  let coefficient = beatCoefficient(loopBeatDivision)

  const maxArray = Array(maxBeatDivision * loopLength).fill(0)
  for (var i = 0; i < array.length; i++) {
    if (array[i] === 1 || array[i] === true) {
      maxArray[Math.floor(i * coefficient)] = 1
    } else {
      maxArray[Math.floor(i * coefficient)] = 0
    }
  }
  return maxArray
}
